// extracted by mini-css-extract-plugin
export default {"table":"DrawnBySummary_table__M4l3n","header":"DrawnBySummary_header__Qiqql","data":"DrawnBySummary_data__qbYFc","totals":"DrawnBySummary_totals__y9AWz"};